export default `
基於《支付服務法》的描述


營運公司名稱
零地有限公司


代表人
成田由紀


公司註冊地址/營業辦公地址
〒330-0854  
埼玉縣埼玉市大宮區櫻木町1丁目195‑1 
大宮SORAMICHI KOZ4樓


硬幣（本網站上的貨幣）所有權限制/期限
硬幣沒有上限。
但是，如果在購買或兌換金幣後，自上次使用金幣起超過 6 個月（包括當日）仍未使用金幣，我們可能會在不提前通知您的情況下刪除您的帳戶。
在這種情況下，硬幣將失效。


硬幣使用地點範圍
硬幣沒有上限。
硬幣（本網站內的貨幣）可以在註冊帳戶內使用。
此外，禁止帳戶轉讓和硬幣轉讓。


使用注意事項
硬幣（本網站內的貨幣）無法退款。


如何查看自己擁有的金幣
您可以在本網站的螢幕上查看。
如果您擁有的金幣有任何變動，金幣的數量將會自動改變。


聯絡資訊
請在這裡聯絡我們。




服務條款
請檢查本網站的使用條款。


`;
